import script from "./ConfigurationViews.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationViews.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationViews.vue?vue&type=style&index=0&id=0e87f7cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e87f7cb"]])

export default __exports__